import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class FreightLocationUnloadActivity extends Component {
	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Freight/FreightLocationUnload/FreightLocationUnloadBrowser")
	}

	render() {
		return (
			<Activity 
				name="FreightLocationUnload"
				RenderedComponent={this.RenderedComponent}
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(FreightLocationUnloadActivity)